import { CodeAPI } from 'api/codeAPI';
import uploadFileToCloud from 'services/uploadFileToCloud';
import saveCodeFileInfo from 'services/saveCodeFileInfo';
import { ICodesTable } from 'interfaces/Code/ICodesTable';
import RESPONSE_CODES from 'constants/responseCodes';
import { IIsciCode } from 'interfaces/IsciCode/IIsciCode';

const processCodeFile = (file: File, code: ICodesTable, isciCode: IIsciCode) => {
  return CodeAPI.getFileUploadPath({
    creativeId: code.creative_id,
    codeId: code.id,
    isciCodeId: isciCode.id,
    filename: file.name }
    ).then((response) => {
      if (response.status === RESPONSE_CODES.OK) {
        return uploadFileToCloud(file, response.data.data.url);
      } else {
        throw new Error(response.data.error?.details);
      }
    }).then((result) => (
      saveCodeFileInfo(file, code.creative_id, code.id, isciCode.id)
    ));
};

export default processCodeFile;
